import React, { useState } from 'react';
import api from '../services/api';
import './ForgotPassword.css';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleForgotPassword = async (e) => {
        e.preventDefault();

        // Clear previous messages
        setMessage('');
        setError('');

        try {
            // Make the request to the backend API
            const response = await api.post('/auth/forgot-password', { email });
            
            // If successful, display success message
            setMessage(response.data.message);
        } catch (error) {
            // Show error message from the server response or fallback
            setError(error.response?.data.message || 'An error occurred while sending the request.');
        }
    };

    return (
        <div className="forgot-password-container">
            <h2>Forgot Password</h2>

            {/* Display success message */}
            {message && <p className="message">{message}</p>}

            {/* Display error message */}
            {error && <p className="error">{error}</p>}

            <form onSubmit={handleForgotPassword}>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input 
                        type="email" 
                        id="email" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        required 
                    />
                </div>
                <button type="submit" className="btn-primary">Request Password Reset</button>
            </form>
        </div>
    );
}

export default ForgotPassword;
